/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Front_Title5Inputs */

const en_svc_rag_knowledge_assistants_front_title5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widget, Slack or WhatsApp front end`)
};

const ar_svc_rag_knowledge_assistants_front_title5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ودجت أو Slack أو واتساب كواجهة`)
};

const bn_svc_rag_knowledge_assistants_front_title5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`উইজেট, Slack বা হোয়াটসঅ্যাপ ফ্রন্ট`)
};

const de_svc_rag_knowledge_assistants_front_title5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widget, Slack oder WhatsApp als Frontend`)
};

const es_svc_rag_knowledge_assistants_front_title5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widget, Slack o WhatsApp como frontal`)
};

const fr_svc_rag_knowledge_assistants_front_title5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widget, Slack ou WhatsApp en frontal`)
};

const pt_svc_rag_knowledge_assistants_front_title5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widget, Slack ou WhatsApp como frente`)
};

const zh_svc_rag_knowledge_assistants_front_title5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`挂件、Slack 或 WhatsApp 前端`)
};

const tr_svc_rag_knowledge_assistants_front_title5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widget, Slack ya da WhatsApp ön yüzü`)
};

const ru_svc_rag_knowledge_assistants_front_title5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виджет, Slack или WhatsApp спереди`)
};

const pl_svc_rag_knowledge_assistants_front_title5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widget, Slack albo WhatsApp z przodu`)
};

/**
* | output |
* | --- |
* | "Widget, Slack or WhatsApp front end" |
*
* @param {Svc_Rag_Knowledge_Assistants_Front_Title5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_front_title5 = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Front_Title5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Front_Title5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_front_title5(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_front_title5(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_front_title5(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_front_title5(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_front_title5(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_front_title5(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_front_title5(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_front_title5(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_front_title5(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_front_title5(inputs)
	return en_svc_rag_knowledge_assistants_front_title5(inputs)
});
export { svc_rag_knowledge_assistants_front_title5 as "svc_rag-knowledge-assistants_FRONT_title" }